import { RefreshCw } from 'lucide-react';
import { Button } from '@tark/shared/components';

export default function OtpResend({ seconds, busy, notice, onResend }: {
  seconds: number; busy: boolean; notice: string; onResend: () => void;
}) {
  return (
    <div className="space-y-2">
      <Button type="button" variant="outline" className="w-full"
        disabled={busy || seconds > 0} onClick={onResend}
        leftIcon={<RefreshCw className="h-4 w-4" />}>
        {seconds > 0 ? `Resend code in ${seconds}s` : 'Resend code'}
      </Button>
      {notice ? <p role="status" className="text-center text-sm text-text-muted">{notice}</p> : null}
    </div>
  );
}
